import { _plus, _minus, _toFixed } from '@/helpers/bigNumber'
import { formatDate } from '@/helpers/formatDate'

const mutations = {
  date: 'SET_DATE',
  amount: 'SET_AMOUNT'
}

const dueDate = () => {
  return {
    date: undefined,
    amount: undefined
  }
}

/**
 * Set Due-Date
 * @param {Array} payload - Set List of Due Date Objects (const "dueDate" line 9).
 */
export const set = ({ commit, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    if (!Array.isArray(payload)) reject(new Error(`${payload} must be an array`))
    let dates = [ ...payload ]
    let mandatory = dates.shift()
    commit('SET_DATE', { key: 'mandatory', value: formatDate(mandatory.date) })
    commit('SET_AMOUNT', { key: 'mandatory', value: mandatory.amount })
    Promise.all([
      new Promise(resolve => resolve(true)),
      ...dates.map(due => dispatch('addItem', { ...due }))
    ]).then(() => {
      resolve()
    }, (err) => {
      reject(err)
    })
  })
}

/**
 * Add Due-Date
 * @param {Object} payload - Due-Date Object.
 */
export const addItem = ({ commit, getters, rootGetters }, payload) => {
  return new Promise((resolve) => {
    if (!payload) {
      payload = dueDate()
      payload.amount = rootGetters['invoice/total'] - getters['totalAmount']
      payload.amount = payload.amount > 0 ? payload.amount : 0
    }
    if (payload.date) payload.date = formatDate(payload.date)
    commit('ADD', payload)
    resolve()
  })
}

export const removeItem = ({ commit }, key) => {
  return new Promise((resolve) => {
    commit('DELETE', key)
    resolve()
  })
}

/**
 * Update Due-Date
 * @param {Object} payload - Due-Date Object (const "dueDate" line 9).
 */
export const updateItem = ({ commit }, payload) => {
  return new Promise((resolve) => {
    let key = payload.key
    Object().keys(payload).filter(k => k !== 'key')
    .forEach(param => {
      commit(mutations[param], { key, param, value: payload[param] })
    })
    resolve()
  })
}

export const empty = ({ commit, dispatch, state }) => {
  return new Promise((resolve) => {
    if (!state.list.length) resolve()
    Promise.all([
      state.list.filter(k => k !== 'mandatory')
      .map((key) => {
        return dispatch('removeItem', key)
      })
    ]).then(() => {
      resolve()
    })
  })
}

export const recalculate = ({ commit, state }, total) => {
  /*
  71018 Recalculates only changes mandatory field
  let old = state.list.reduce((acc, x) => {
    return _plus(acc, state._[x].amount)
  }, 0)
  let factor = old ? _div(total, old) : 1
  state.list.reduceRight((acc, key, index) => {
    let value = _toFixed(_times(state._[key].amount, factor), 2)
    if (index < 1) commit('SET_AMOUNT', { key, value: acc })
    else commit('SET_AMOUNT', { key, value })
    return _minus(acc, value)
  }, total)
  */
  let dated = state.list.reduce((acc, x) => {
    if (x === 'mandatory') return acc
    return _toFixed(_plus(acc, state._[x].amount), 2)
  }, 0)
  let mandatory = _toFixed(_minus(total, dated), 2)
  state._['mandatory'].amount = mandatory > 0 ? mandatory : 0
}
